/**
 * R2 object keys use .webp; legacy URLs or keys may still use .png.
 */
export const cdnObjectKeyPreferWebp = (objectKey: string): string =>
  objectKey.replace(/\.png$/i, '.webp');
